// Identifies a predicate/column slot in the transactions view. Most values
// correspond to a visible UI column, but ID is filter-only — it has no header
// or cell renderer and stays `shown: false`. Treat this enum as "predicate
// slot" rather than strictly "visible column."
export enum TransactionColumn {
  DATE,
  ACCOUNT,
  TYPE,
  MERCHANT,
  DESCRIPTION,
  CATEGORY,
  RULE,
  REVIEWED,
  AMOUNT,
  ID,
  TAGS,
}
